import { brand } from "brand/theme";

const BAR = {
  success: brand.colors.accent,
  primary: brand.colors.accent,
  error: brand.colors.critical,
  warning: "#B45309",
  info: brand.colors.ink,
  secondary: brand.colors.muted,
};

function severityAccent(color) {
  return BAR[color] || BAR.primary;
}

function cleanAlert(color) {
  const accent = severityAccent(color);
  return {
    color: brand.colors.ink,
    backgroundColor: brand.colors.surface,
    border: `1px solid ${brand.colors.line}`,
    borderRadius: brand.radius.md,
    boxShadow: "none",
    fontFamily: brand.fonts.body,
    alignItems: "center",
    padding: "12px 14px 12px 16px",
    overflow: "hidden",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: 4,
      backgroundColor: accent,
    },
    "& .MuiAlert-icon": {
      display: "none",
    },
    "& .MuiAlert-message": {
      padding: 0,
      fontSize: "0.9375rem",
      fontWeight: 500,
      lineHeight: 1.45,
      color: brand.colors.ink,
      fontFamily: brand.fonts.body,
    },
    "& .MuiAlert-action": {
      marginRight: 0,
      paddingLeft: 8,
      paddingTop: 0,
      alignItems: "center",
      "& .MuiIconButton-root": {
        color: brand.colors.muted,
        padding: 4,
        borderRadius: 'var(--brand-radius-md)',
        "&:hover": {
          backgroundColor: brand.colors.accentSoft,
          color: brand.colors.accent,
        },
      },
    },
  };
}

// ==============================|| OVERRIDES - ALERT ||============================== //

export default function Alert() {
  const colors = [
    "primary",
    "secondary",
    "error",
    "success",
    "info",
    "warning",
  ];

  const byVariant = (prefix) =>
    Object.fromEntries(
      colors.map((color) => [
        `${prefix}${color[0].toUpperCase()}${color.slice(1)}`,
        cleanAlert(color),
      ]),
    );

  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          ...cleanAlert("primary"),
        },
        icon: {
          display: "none",
        },
        message: {
          padding: 0,
          marginTop: 0,
        },
        action: {
          paddingTop: 0,
          marginRight: 0,
        },
        border: cleanAlert("primary"),
        ...byVariant("standard"),
        ...byVariant("outlined"),
        ...byVariant("filled"),
      },
    },
  };
}
